// ── Shared constants and helpers for Donate pages ─────────────────────────

export const RECYCLE_ICON = 'https://customer-assets-lqy194kg.emergentagent.net/job_e70fd7ab-deee-4526-bb73-77bb3d550c8c/artifacts/g7fq7qqd_recycle-sign.png';

export const DONATE_ITEMS = [
  { word: 'Clothes',     cat: 'Clothes',     slug: 'donate-clothes',     icons: ['https://customer-assets-lqy194kg.emergentagent.net/job_e70fd7ab-deee-4526-bb73-77bb3d550c8c/artifacts/zds745sh_shirt.png'] },
  { word: 'Notebooks',   cat: 'Notebooks',   slug: 'donate-notebooks',   icons: ['https://customer-assets-lqy194kg.emergentagent.net/job_e70fd7ab-deee-4526-bb73-77bb3d550c8c/artifacts/66ezt8ij_notebook.png'] },
  { word: 'Idols',       cat: 'Idols',       slug: 'donate-idols',       icons: ['https://customer-assets-lqy194kg.emergentagent.net/job_e70fd7ab-deee-4526-bb73-77bb3d550c8c/artifacts/4h5502rl_ganesha.png'] },
  { word: 'Electronics', cat: 'Electronics', slug: 'donate-electronics', icons: ['https://customer-assets-lqy194kg.emergentagent.net/job_e70fd7ab-deee-4526-bb73-77bb3d550c8c/artifacts/f3q6cfya_device.png'] },
  {
    word: 'Items', cat: 'Others', slug: 'donate-others',
    icons: [
      'https://customer-assets-lqy194kg.emergentagent.net/job_e70fd7ab-deee-4526-bb73-77bb3d550c8c/artifacts/35upt502_air-mattress.png',
      'https://customer-assets-lqy194kg.emergentagent.net/job_e70fd7ab-deee-4526-bb73-77bb3d550c8c/artifacts/vj98slq1_sofa.png',
      'https://customer-assets-lqy194kg.emergentagent.net/job_e70fd7ab-deee-4526-bb73-77bb3d550c8c/artifacts/yzi6tqy6_shoe.png',
    ],
  },
];

export const DONATE_MODES = ['Pick Up', 'Drop Off'];

export const BLURU_CENTER = { lat: 12.9716, lng: 77.5946 };
export const BLURU_BOUNDS = { north: 13.16, south: 12.79, east: 77.78, west: 77.41 };

// ── Mock donation places ───────────────────────────────────────────────────

export const MOCK_DONATION_PLACES = [
  {
    id: 'dp1',
    name: 'Goonj',
    loc_name: 'Koramangala Drop-off Centre',
    items: ['Clothes', 'Notebooks', 'Electronics', 'Others'],
    pickup: { available: true, how_to_book: 'Call or WhatsApp to schedule a free home pickup. Min 5 kg material.', link: null },
    dropoff: { available: true, schedule: 'Mon–Sat · 10 AM – 6 PM' },
    contact: { website: 'https://goonj.org', instagram: 'goonj', phone: '+91 98765 43210', whatsapp: '+91 98765 43210', email: 'blr@goonj.org' },
    fee_rewards: 'Free',
    fee_value: 0,
    remarks: "One of India's largest material redistribution NGOs. Min 10 garments for clothes.",
    location: { lat: 12.9352, lng: 77.6245, address: 'Koramangala, Bengaluru' },
  },
  {
    id: 'dp2',
    name: 'Samarthanam Trust for the Disabled',
    loc_name: 'Domlur Head Office',
    items: ['Electronics', 'Clothes', 'Notebooks'],
    pickup: { available: false, how_to_book: null, link: null },
    dropoff: { available: true, schedule: 'Mon–Fri · 9 AM – 5 PM' },
    contact: { website: 'https://samarthanam.org', instagram: 'samarthanam', phone: '+91 80 2546 9999', whatsapp: null, email: 'info@samarthanam.org' },
    fee_rewards: 'Free · 80G Tax Exemption',
    fee_value: 0,
    remarks: 'Electronics and clothes refurbished or redistributed to differently-abled individuals.',
    location: { lat: 12.9601, lng: 77.6381, address: 'Domlur, Bengaluru' },
  },
  {
    id: 'dp3',
    name: 'The/Nudge Foundation',
    loc_name: 'HSR Layout Office',
    items: ['Clothes'],
    pickup: { available: true, how_to_book: 'Fill the online request form. Pickup within 3 business days.', link: 'https://thenudge.org/donate' },
    dropoff: { available: true, schedule: 'Tue, Thu, Sat · 11 AM – 4 PM' },
    contact: { website: 'https://thenudge.org', instagram: 'the_nudge_foundation', phone: null, whatsapp: '+91 99001 12345', email: 'donate@thenudge.org' },
    fee_rewards: 'Free',
    fee_value: 0,
    remarks: 'Clothes distributed to urban poor communities. Only donate wearable items.',
    location: { lat: 12.9116, lng: 77.6389, address: 'HSR Layout, Bengaluru' },
  },
  {
    id: 'dp4',
    name: 'Parikrma Humanity Foundation',
    loc_name: 'Banashankari Campus',
    items: ['Notebooks', 'Electronics'],
    pickup: { available: false, how_to_book: null, link: null },
    dropoff: { available: true, schedule: 'Mon–Sat · 9 AM – 5 PM' },
    contact: { website: 'https://parikrma.org', instagram: 'parikrmahumanity', phone: '+91 80 2657 1010', whatsapp: null, email: 'info@parikrma.org' },
    fee_rewards: 'Free · 80G Tax Exemption',
    fee_value: 0,
    remarks: 'Notebooks and working electronics given to underprivileged school children.',
    location: { lat: 12.9109, lng: 77.5509, address: 'Banashankari, Bengaluru' },
  },
  {
    id: 'dp5',
    name: 'Youth For Seva',
    loc_name: 'BTM Layout Hub',
    items: ['Clothes', 'Notebooks'],
    pickup: { available: true, how_to_book: 'WhatsApp your address and preferred time slot.', link: 'https://wa.me/918880012345' },
    dropoff: { available: false, schedule: null },
    contact: { website: 'https://youthforseva.org', instagram: 'youthforseva', phone: null, whatsapp: '+91 88800 12345', email: null },
    fee_rewards: 'Free',
    fee_value: 0,
    remarks: 'Run by volunteers. Weekday pickups available across Bengaluru.',
    location: { lat: 12.9166, lng: 77.6101, address: 'BTM Layout, Bengaluru' },
  },
  {
    id: 'dp6',
    name: 'Rotary Club Bengaluru South',
    loc_name: 'Jayanagar Collection Point',
    items: ['Electronics', 'Others'],
    pickup: { available: false, how_to_book: null, link: null },
    dropoff: { available: true, schedule: 'Sat & Sun · 10 AM – 2 PM' },
    contact: { website: null, instagram: null, phone: '+91 80 2222 3333', whatsapp: '+91 80 2222 3333', email: 'rotarybngls@gmail.com' },
    fee_rewards: 'Free',
    fee_value: 0,
    remarks: 'Electronics repaired and donated to schools. Only working or repairable items accepted.',
    location: { lat: 12.9252, lng: 77.5938, address: 'Jayanagar, Bengaluru' },
  },
  {
    id: 'dp7',
    name: 'HelpAge India Bengaluru',
    loc_name: 'Malleshwaram Office',
    items: ['Clothes', 'Others'],
    pickup: { available: true, how_to_book: 'Call the helpline to schedule. Min 10 items required.', link: null },
    dropoff: { available: true, schedule: 'Mon–Fri · 10 AM – 5 PM' },
    contact: { website: 'https://helpageindia.org', instagram: 'helpageindia', phone: '1800-180-1253', whatsapp: null, email: 'bengaluru@helpageindia.org' },
    fee_rewards: 'Free · 80G Tax Exemption',
    fee_value: 0,
    remarks: 'Clothes and household items distributed to the elderly and destitute.',
    location: { lat: 13.0068, lng: 77.5649, address: 'Malleshwaram, Bengaluru' },
  },
  {
    id: 'dp8',
    name: 'Akshara Foundation',
    loc_name: 'Rajajinagar Office',
    items: ['Notebooks'],
    pickup: { available: false, how_to_book: null, link: null },
    dropoff: { available: true, schedule: 'Mon–Fri · 9 AM – 5 PM' },
    contact: { website: 'https://akshara.org.in', instagram: 'akshara_foundation', phone: '+91 80 2346 7890', whatsapp: null, email: 'info@akshara.org.in' },
    fee_rewards: 'Free',
    fee_value: 0,
    remarks: 'Notebooks and stationery for government school students across Karnataka.',
    location: { lat: 12.9933, lng: 77.5545, address: 'Rajajinagar, Bengaluru' },
  },
  {
    id: 'dp9',
    name: 'Isha Foundation Bengaluru',
    loc_name: 'Yelahanka Outreach Centre',
    items: ['Idols', 'Clothes'],
    pickup: { available: false, how_to_book: null, link: null },
    dropoff: { available: true, schedule: 'Daily · 8 AM – 8 PM' },
    contact: { website: 'https://isha.sadhguru.org', instagram: 'ishafoundation', phone: '+91 83000 83111', whatsapp: null, email: null },
    fee_rewards: 'Free',
    fee_value: 0,
    remarks: 'Eco-friendly idol immersion available. Clothes sent to rural outreach programs.',
    location: { lat: 13.1007, lng: 77.5963, address: 'Yelahanka, Bengaluru' },
  },
  {
    id: 'dp10',
    name: 'GreenWaste Recyclers',
    loc_name: 'Electronic City Recycling Facility',
    items: ['Electronics', 'Others'],
    pickup: { available: true, how_to_book: 'Book via website or WhatsApp. Minimum 5 kg for free pickup.', link: 'https://greenwasterecyclers.in' },
    dropoff: { available: true, schedule: 'Mon–Sat · 8 AM – 7 PM' },
    contact: { website: 'https://greenwasterecyclers.in', instagram: null, phone: '+91 73382 11223', whatsapp: '+91 73382 11223', email: 'pickup@greenwasterecyclers.in' },
    fee_rewards: 'Free · Cash reward for working devices',
    fee_value: -1,
    remarks: 'Certified e-waste recycler. Data wipe certificate provided on request.',
    location: { lat: 12.8399, lng: 77.6771, address: 'Electronic City, Bengaluru' },
  },
  {
    id: 'dp11',
    name: 'Kabadiwalla Connect',
    loc_name: 'Bellandur Operations Hub',
    items: ['Electronics', 'Others'],
    pickup: { available: true, how_to_book: 'Schedule via app or WhatsApp. Available 7 days a week.', link: 'https://kabadiwalla.com' },
    dropoff: { available: false, schedule: null },
    contact: { website: 'https://kabadiwalla.com', instagram: 'kabadiwalla_connect', phone: null, whatsapp: '+91 99994 12345', email: 'hello@kabadiwalla.com' },
    fee_rewards: 'Cash reward based on weight',
    fee_value: -1,
    remarks: 'Connects you with trained kabadiwallas for responsible e-waste and scrap disposal.',
    location: { lat: 12.9257, lng: 77.6793, address: 'Bellandur, Bengaluru' },
  },
  {
    id: 'dp12',
    name: 'Sparsha Trust',
    loc_name: 'Whitefield Centre for Special Needs',
    items: ['Clothes', 'Notebooks'],
    pickup: { available: true, how_to_book: 'Call or email to schedule. Pickup available on weekends.', link: null },
    dropoff: { available: true, schedule: 'Mon–Sat · 10 AM – 5 PM' },
    contact: { website: 'https://sparshatrust.org', instagram: null, phone: '+91 80 4119 0750', whatsapp: null, email: 'contact@sparshatrust.org' },
    fee_rewards: 'Free',
    fee_value: 0,
    remarks: 'Supports children with intellectual disabilities. Clothes must be in wearable condition.',
    location: { lat: 12.9698, lng: 77.7500, address: 'Whitefield, Bengaluru' },
  },
  {
    id: 'dp13',
    name: 'Concern India Foundation',
    loc_name: 'Indiranagar Donation Centre',
    items: ['Clothes', 'Notebooks', 'Others'],
    pickup: { available: true, how_to_book: 'Register on website and select a pickup slot.', link: 'https://concernindia.org/donate' },
    dropoff: { available: false, schedule: null },
    contact: { website: 'https://concernindia.org', instagram: 'concernindiafoundation', phone: '+91 80 4112 6543', whatsapp: null, email: 'blr@concernindia.org' },
    fee_rewards: 'Free · 80G Tax Exemption',
    fee_value: 0,
    remarks: 'Items distributed to underprivileged children and women across Karnataka.',
    location: { lat: 12.9784, lng: 77.6408, address: 'Indiranagar, Bengaluru' },
  },
];

// ── Helpers ────────────────────────────────────────────────────────────────

export function haversine(lat1, lng1, lat2, lng2) {
  const R = 6371;
  const dLat = (lat2 - lat1) * Math.PI / 180;
  const dLng = (lng2 - lng1) * Math.PI / 180;
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) * Math.sin(dLng / 2) ** 2;
  return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}

/**
 * Filter by selected categories + modes array, sort by proximity.
 * modes: [] = no filter (show all), ['Drop Off'] = drop-off only,
 *        ['Pick Up'] = pick-up only, ['Drop Off','Pick Up'] = either.
 */
export function getSortedResults(places, categories, modes, coords) {
  // Category filter
  const filtered = categories.length === 0
    ? places
    : places.filter((p) => p.items.some((item) => categories.includes(item)));

  // Mode filter
  let modeFiltered = filtered;
  if (modes.length === 1 && modes[0] === 'Drop Off') {
    modeFiltered = filtered.filter((p) => p.dropoff.available);
  } else if (modes.length === 1 && modes[0] === 'Pick Up') {
    modeFiltered = filtered.filter((p) => p.pickup.available);
  }
  // 0 or 2 modes selected → no mode filter

  if (!coords) return modeFiltered;
  return [...modeFiltered].sort((a, b) =>
    haversine(coords.lat, coords.lng, a.location?.lat ?? 0, a.location?.lng ?? 0) -
    haversine(coords.lat, coords.lng, b.location?.lat ?? 0, b.location?.lng ?? 0)
  );
}
